import React, { useEffect, useRef } from 'react';
import { Card, Col, Form, Row, Button } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import moment from "moment";
import axios from 'helpers/api';
import { toast } from 'react-toastify';
import { createIframeReportBlobUrl } from 'helpers/iframeReportPreview';
import AdvanceTablePagination from 'components/common/advance-table/AdvanceTablePagination';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import Spinner from 'react-bootstrap/Spinner';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import ShimmerUI from 'components/ShimmerUI/PatientShimmer';
import paths from 'routes/paths';
import { Link } from 'react-router-dom';

//const [medsheet, setMedSheet] = useState([]);

const SplitMedReport = (props) => {
    const [loader, setLoader] = useState(false);
    const [spinner, showSpinner] = useState(false);
    const [iframeSrc, setIframeSrc] = useState(null);
    const [tableData, setTableData] = useState([]);
    const [wholeData, setWholeData] = useState([]);
    const tableRef = useRef(null);
    const [formData, setFormData] = useState({
        isShowAllFacility: false,
    })
    const facilityList = JSON.parse(localStorage.getItem("facilitiesData"));
    let facilityObj = facilityList.reduce((obj, item) => {
        obj[item.value] = item.key;
        return obj;
    }, {})
    const columns = [
        {
            accessorKey: 'facility_name',
            header: 'Facility Name',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'patient_name',
            header: 'Patient Name',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            },
            cell: ({ row: { original } }) => {
                const patientDetails = paths.patientDetails;
                return (
                    <Link to={{ pathname: `${patientDetails}/${original.patient_id}` }}>
                        {original.patient_name}
                    </Link>
                )
            }
        },
        {
            accessorKey: 'drug',
            header: 'Drug',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            },
            cell: ({ row: { original } }) => {
                const editPrescription = paths.editPrescription;
                return (
                    <Link to={{ pathname: `${editPrescription}/${original.prescription_id}` }}>
                        {original.drug}
                    </Link>
                )
            }
        }
    ]

    useEffect(() => {
        fetchData()
    }, [props.selectedFacility])

    useEffect(() => {
        fetchAllData();
    }, [])

    const fetchAllData = async () => {
        let results = [];
        let pelmedsTreatmentUrl = `${process.env.REACT_APP_SERVER_URL}` + "/reports/splitmed-list";
        let pelmedsTreatmentData = {
            facility_id: '-999',
        };
        let tokenStr = localStorage.getItem("accessToken");
        const data = await axios.post(pelmedsTreatmentUrl, pelmedsTreatmentData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });
        data?.data?.splitmeds?.map((item, index) => {
            results.push({
                prescription_id: item.prescription_id,
                patient_id: item.patient_id,
                patient_name: (`${item.last_name},${item.first_name}`),
                facility_name: facilityObj[item.facility_id],
                drug: item.drug + " " + (item.strength_value ? item.strength_value : "") + " " + (item.strength ? item.strength : ""),
            })
        })
        setWholeData(results);
        setFormData({ ...formData, isShowAllFacility: true });//default checked
        props.setFlag(true);
    }


    const fetchData = async () => {
        setLoader(true);
        let results = [];
        let pelmedsTreatmentUrl = `${process.env.REACT_APP_SERVER_URL}` + "/reports/splitmed-list";
        let pelmedsTreatmentData = {
            facility_id: props.selectedFacility,
        };
        let tokenStr = localStorage.getItem("accessToken");
        try {
            const data = await axios.post(pelmedsTreatmentUrl, pelmedsTreatmentData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });
            data?.data?.splitmeds?.map((item, index) => {
                results.push({
                    prescription_id: item.prescription_id,
                    patient_id: item.patient_id,
                    patient_name: (`${item.last_name},${item.first_name}`),
                    facility_name: facilityObj[item.facility_id],
                    drug: item.drug + " " + (item.strength_value ? item.strength_value : "") + " " + (item.strength ? item.strength : ""),
                })
            })
            setTableData(results);
            setLoader(false);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoader(false);
        }
    }


    const handleSubmit = async e => {
        e.preventDefault();
        if (!props.validateFacility()) return;
        showSpinner(true);

        let tokenStr = localStorage.getItem("accessToken");
        let pelmedsTreatmentUrl = `${process.env.REACT_APP_SERVER_URL}` + "/reports/splitmed-report";

        let pelmedsTreatmentData = {
            facility_id: formData.isShowAllFacility ? '-999' : localStorage.getItem("reportFacilityId"),
        };

        const data = await axios.post(pelmedsTreatmentUrl, pelmedsTreatmentData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });


        if (data.data.status == false) {
            toast.error(data.data.message);

        }
        else {
            toast.success("Splitmed Report Generated Successfully");
            const { blobUrl } = await createIframeReportBlobUrl(data.data);
            setIframeSrc(blobUrl);
        }
        showSpinner(false);


    };

    const handleDownloadCSV = async () => {
        if (!props.validateFacility()) return;
        showSpinner(true);

        let tokenStr = localStorage.getItem("accessToken");
        let pelmedsTreatmentUrl = `${process.env.REACT_APP_SERVER_URL}` + "/reports/splitmed-report";

        let pelmedsTreatmentData = {
            facility_id: formData.isShowAllFacility ? '-999' : localStorage.getItem("reportFacilityId"),
            is_print: "csv"
        };

        const data = await axios.post(pelmedsTreatmentUrl, pelmedsTreatmentData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });


        if (data.data.status == false) {
            toast.error(data.data.message);

        }
        else {
           
            const disposition = data.headers['content-disposition'];
            const filename = disposition
                ? disposition.split('filename=')[1]?.replace(/"/g, '').trim()
                : 'split-med-report.csv';

            const url = URL.createObjectURL(new Blob([data.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();

            link.parentNode.removeChild(link);
            URL.revokeObjectURL(url);
             toast.success("Splitmed Report Exported Successfully");
        }
        showSpinner(false);


    };

    const table = useAdvanceTable({
        data: tableData,
        columns,
        selection: false,
        sortable: true,
        pagination: true
    });

    const table2 = useAdvanceTable({
        data: wholeData,
        columns,
        selection: false,
        sortable: true,
        pagination: true
    });

    const tableHeight = tableRef.current ? tableRef.current.clientHeight : 0;
    const isDownloadDisabled =
        spinner ||
        (
            !formData.isShowAllFacility &&
            (props.selectedFacility === '' || tableData.length === 0)
        ) ||
        (
            formData.isShowAllFacility &&
            wholeData.length === 0
        );

    return (
        <div className="mt-4">
            <Form.Group className="mb-3">
                <Form.Check
                    type="checkbox"
                    label="All Facility"
                    name="isShowAllFacility"
                    onChange={(e) => {
                        props.setFlag(e.target.checked ? true : false);
                        setFormData({ ...formData, isShowAllFacility: e.target.checked ? true : false })
                    }
                    }
                    checked={formData.isShowAllFacility}
                />
            </Form.Group>
            {formData.isShowAllFacility == true ? <AdvanceTableProvider {...table2}>
                <Card className="mb-3 shadow-sm rounded-3">
                    <Card.Body className="p-4">
                        {wholeData.length > 0 ? (
                            <Row>
                                <Col xs="4" className="mb-2 view-patient-search-holder">
                                    <AdvanceTableSearchBox placeholder="Search..." />
                                </Col>
                                <Col xs="12">
                                    <AdvanceTable
                                        headerClassName="bg-200 text-nowrap align-middle text-center fw-semibold"
                                        rowClassName="text-nowrap align-middle text-center"
                                        tableProps={{
                                            size: 'sm',
                                            striped: true,
                                            className: 'fs-12 mb-0 overflow-hidden table-bordered shadow-sm'
                                        }}
                                    />
                                </Col>
                            </Row>
                        ) : (
                            <div className="d-flex justify-content-center align-items-center text-center" style={{ height: '150px' }}>
                                <p className="text-danger fw-bold mb-0">No data available for this option. Please select another Facility.</p>
                            </div>
                        )}
                    </Card.Body>
                    <Card.Footer className="bg-light rounded-3 py-3">
                        <div className="mt-3">
                            <AdvanceTableFooter rowInfo navButtons rowsPerPageSelection />
                        </div>
                    </Card.Footer>
                </Card>
            </AdvanceTableProvider> :
                <AdvanceTableProvider {...table}>
                    <Card className="mb-3 shadow-sm rounded-3">
                        <Card.Body className="p-4">
                            {loader ? (
                                <div className="d-flex justify-content-center align-items-center" style={{ height: `${tableHeight}px` }}>
                                    <Spinner animation="border" role="status" className="mx-auto"></Spinner>
                                </div>
                            ) : tableData.length > 0 ? (
                                <Row>
                                    <Col xs="4" className="mb-2 view-patient-search-holder">
                                        <AdvanceTableSearchBox placeholder="Search..." />
                                    </Col>
                                    <Col xs="12">
                                        <AdvanceTable
                                            headerClassName="bg-200 text-nowrap align-middle text-center fw-semibold"
                                            rowClassName="text-nowrap align-middle text-center"
                                            tableProps={{
                                                size: 'sm',
                                                striped: true,
                                                className: 'fs-12 mb-0 overflow-hidden table-bordered shadow-sm'
                                            }}
                                        />
                                    </Col>
                                </Row>
                            ) : (
                                <div className="d-flex justify-content-center align-items-center text-center" style={{ height: '150px' }}>
                                    <p className="text-danger fw-bold mb-0">No data available for this option. Please select another Facility.</p>
                                </div>
                            )}
                        </Card.Body>
                        <Card.Footer className="bg-light rounded-3 py-3">
                            <div className="mt-3">
                                <AdvanceTableFooter rowInfo navButtons rowsPerPageSelection />
                            </div>
                        </Card.Footer>
                    </Card>
                </AdvanceTableProvider>}
            <Form>
                <Row>
                    <Col xs={6} className="text-center">
                        {spinner ? (
                            <Button variant="primary" disabled className="mt-3 w-75 px-4 py-2">
                                <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
                                <span className="ms-2">Fetching...</span>
                            </Button>
                        ) : (
                            <Button disabled={isDownloadDisabled} onClick={handleSubmit} color="primary" className="mt-3 w-75 px-4 py-2">
                                Download Report
                            </Button>
                        )}
                    </Col>
                    <Col xs={6} className="text-center">
                        {spinner ? (
                            <Button variant="primary" disabled className="mt-3 w-75 px-4 py-2">
                                <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
                                <span className="ms-2">Fetching...</span>
                            </Button>
                        ) : (
                            <Button disabled={isDownloadDisabled} onClick={handleDownloadCSV} color="primary" className="mt-3 w-75 px-4 py-2">
                                Export CSV
                            </Button>
                        )}
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col>
                        <div style={{ height: 0, overflow: 'hidden' }}>
                            {iframeSrc && (
                                <iframe
                                    src={iframeSrc}
                                    style={{ width: "100%", height: "400px", border: "none", borderRadius: "8px" }}
                                    title="Preview Content"
                                />
                            )}
                        </div>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col xs={12} className="text-end">
                        <Form.Label><span className="text-danger">*</span> indicates required field</Form.Label>
                    </Col>
                </Row>
            </Form>
        </div>

    );
};

SplitMedReport.propTypes = {
    layout: PropTypes.string,
    hasLabel: PropTypes.bool
};

SplitMedReport.defaultProps = {
    layout: 'simple',
    hasLabel: false
};

export default SplitMedReport;

